import type { Maybe } from '@adornis/base/utilTypes.js';
import { ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';

@Entity()
export class CvReviewUsage extends MongoEntity {
  static override _class = 'CvReviewUsage';
  static override _collectionName = 'cv-review-usage';

  constructor(doc: PartialEntityData<CvReviewUsage>) {
    super(doc);
  }

  @Field(() => ID)
  userID!: string;

  @Field(() => Date)
  reviewedAt: Maybe<Date>;
}
